export function remapSectionId(sectionId: string, sectionsMapping: Record<string, string>): string {
  return sectionsMapping[sectionId] ?? sectionId;
}

export function remapBlockId(blockId: string, blocksMapping: Record<string, string>): string {
  return blocksMapping[blockId] ?? blockId;
}

export function resolveRemappedId(id: string, mapping: Record<string, string>): string {
  let currentId = id;
  const visited = new Set<string>();

  while (mapping[currentId] && !visited.has(currentId)) {
    visited.add(currentId);
    currentId = mapping[currentId];
  }

  return currentId;
}

export function mergeIdMappings(
  existing: Record<string, string>,
  incoming: Record<string, string>,
): Record<string, string> {
  if (Object.keys(incoming).length === 0) {
    return existing;
  }

  const merged = { ...existing };

  for (const [fromId, toId] of Object.entries(incoming)) {
    merged[fromId] = resolveRemappedId(toId, incoming);
  }

  for (const [fromId, toId] of Object.entries(merged)) {
    merged[fromId] = resolveRemappedId(toId, merged);
  }

  return merged;
}

export function remapParentBlockId(
  parentBlockId: string | null | undefined,
  blocksMapping: Record<string, string>,
): string | null | undefined {
  if (typeof parentBlockId !== 'string') {
    return parentBlockId;
  }

  return resolveRemappedId(parentBlockId, blocksMapping);
}
